import { EntityBase } from './EntityBase';
import { Material } from './Material';
import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class MaterialMonograph extends EntityBase {

    /// <code> Place custom code between <code> tags

    /// </code>

    // Generated code. Do not place code below this line.
    materialMonographId: number;
    materialId: number;
    fileName: string;
    fileLabel: string;
    notes: string;
    created: Date;
    createdUser: string;
    modified: Date;
    modifyUser: string;
    rowVersion: number;
    material: Material;
}
